React = require 'react'
{ Component, PropTypes } = React
{ Alert, Button, ButtonGroup, Input, Table } = require 'react-bootstrap'
require '../../styles/SummaryQuestions'
InnerGlyphicon = require './InnerGlyphicon'
serialize = require 'form-serialize'
map = require 'lodash/map'
merge = require 'lodash/merge'

class SummaryQuestionsComponent extends Component
	@propTypes:
		onSubmit: PropTypes.func.isRequired

		# Redux-Form props
		error: PropTypes.string
		fields: PropTypes.object.isRequired
		handleSubmit: PropTypes.func.isRequired
		submitting: PropTypes.bool.isRequired

	onSubmit: =>
		form = document.querySelector '#summary-questions-form'
		values = serialize form, hash: true
		valuesModifiedForApi = map values, (value, key) ->
			obj = observation_question_id: key
			merge obj, value
			obj.observed = 1 if obj.observed == 'on'
			obj
		@props.onSubmit valuesModifiedForApi

	render: =>
		{ handleSubmit, submitting } = @props

		React.createElement("div", {"className": "container summary-questions"},
			React.createElement("div", {"className": "row"},
				React.createElement("div", {"className": "col-md-12"},
					React.createElement("h1", null, "Summary questions"),

					React.createElement("h3", null, "OLOS Classroom Learning Environment Checklist"),

					React.createElement("form", {"id": "summary-questions-form", "onSubmit": (handleSubmit @onSubmit)},
						React.createElement(Table, {"striped": true, "className": "checklist"},
							React.createElement("thead", null,
								React.createElement("tr", null,
									React.createElement("th", {"className": "yes-no"}, "Observed?"),
									React.createElement("th", {"className": "behavior"}, "Behavior"),
									React.createElement("th", {"classNames": "notes"}, "Notes")
								)
							),
							React.createElement("tbody", null,
								React.createElement("tr", null,
									React.createElement("td", {"className": "yes-no"}, React.createElement("input", {"name": "[1][observed]", "type": "checkbox"})),
									React.createElement("td", {"className": "behavior"}, "Teacher uses small groups and stations while students are working with peers or alone"),
									React.createElement("td", {"className": "notes"}, React.createElement("textarea", {"name": "[1][text]", "rows": "4"}))
								),
								React.createElement("tr", null,
									React.createElement("td", {"className": "yes-no"}, React.createElement("input", {"name": "[2][observed]", "type": "checkbox"})),
									React.createElement("td", {"className": "behavior"}, "Teacher and students use an observable, efficient, and working system when students transition from one activity or location in the classroom to another"),
									React.createElement("td", {"className": "notes"}, React.createElement("textarea", {"name": "[2][text]", "rows": "4"}))
								),
								React.createElement("tr", null,
									React.createElement("td", {"className": "yes-no"}, React.createElement("input", {"name": "[3][observed]", "type": "checkbox"})),
									React.createElement("td", {"className": "behavior"}, "Teacher and students follow classroom rules and routines"),
									React.createElement("td", {"className": "notes"}, React.createElement("textarea", {"name": "[3][text]", "rows": "4"}))
								),
								React.createElement("tr", null,
									React.createElement("td", {"className": "yes-no"}, React.createElement("input", {"name": "[4][observed]", "type": "checkbox"})),
									React.createElement("td", {"className": "behavior"}, "Teacher talk is encouraging and respectful"),
									React.createElement("td", {"className": "notes"}, React.createElement("textarea", {"name": "[4][text]", "rows": "4"}))
								),
								React.createElement("tr", null,
									React.createElement("td", {"className": "yes-no"}, React.createElement("input", {"name": "[5][observed]", "type": "checkbox"})),
									React.createElement("td", {"className": "behavior"}, "Overall support for students’ social- emotional development"),
									React.createElement("td", {"className": "notes"}, React.createElement("textarea", {"name": "[5][text]", "rows": "4"}))
								)
							)
						),

						React.createElement("h3", null, "Structural Aspects of Classroom"),

						React.createElement(Table, {"striped": true, "className": "structural"},
							React.createElement("tbody", null,
								React.createElement("tr", null,
									React.createElement("td", {"className": "characteristic"}, "Number of students"),
									React.createElement("td", {"className": "notes"}, React.createElement(Input, {"name": "[6][numeric_value]", "className": "notes", "type": "number", "defaultValue": "0"}))
								),
								React.createElement("tr", null,
									React.createElement("td", {"className": "characteristic"}, "Number of teachers"),
									React.createElement("td", {"className": "notes"}, React.createElement(Input, {"name": "[7][numeric_value]", "className": "notes", "type": "number", "defaultValue": "0"}))
								),
								React.createElement("tr", null,
									React.createElement("td", {"className": "characteristic"}, "Number of Aides\x2FParaprofessionals"),
									React.createElement("td", {"className": "notes"}, React.createElement(Input, {"name": "[8][numeric_value]", "className": "notes", "type": "number", "defaultValue": "0"}))
								),
								React.createElement("tr", null,
									React.createElement("td", {"className": "characteristic"}, "Number of volunteers (e.g., parents)"),
									React.createElement("td", {"className": "notes"}, React.createElement(Input, {"name": "[9][numeric_value]", "className": "notes", "type": "number", "defaultValue": "0"}))
								),
								React.createElement("tr", null,
									React.createElement("td", {"className": "characteristic"}, "How well are aides\x2Fparaprofessionals and volunteers used?"),
									React.createElement("td", {"className": "notes"}, React.createElement(Input, {"name": "[11][text]", "type": "text", "className": "notes"}))
								),
								React.createElement("tr", null,
									React.createElement("td", {"className": "characteristic"}, "Classroom clutter?"),
									React.createElement("td", {"className": "notes"}, React.createElement(Input, {"name": "[12][text]", "type": "text", "className": "notes"}))
								),
								React.createElement("tr", null,
									React.createElement("td", {"className": "characteristic"}, "Curriculum – Literacy"),
									React.createElement("td", {"className": "notes"}, React.createElement(Input, {"name": "[13][text]", "type": "text", "className": "notes"}))
								),
								React.createElement("tr", null,
									React.createElement("td", {"className": "characteristic"}, "Curriculum – Mathematics"),
									React.createElement("td", {"className": "notes"}, React.createElement(Input, {"name": "[14][text]", "type": "text", "className": "notes"}))
								),
								React.createElement("tr", null,
									React.createElement("td", {"className": "characteristic"}, "Curriculum – Science"),
									React.createElement("td", {"className": "notes"}, React.createElement(Input, {"name": "[15][text]", "type": "text", "className": "notes"}))
								),
								React.createElement("tr", null,
									React.createElement("td", {"className": "characteristic"}, "Curriculum – Social Studies"),
									React.createElement("td", {"className": "notes"}, React.createElement(Input, {"name": "[16][text]", "type": "text", "className": "notes"}))
								),
								React.createElement("tr", null,
									React.createElement("td", {"className": "characteristic"}, "Bilingual instruction?"),
									React.createElement("td", {"className": "notes"}, React.createElement(Input, {"name": "[17][text]", "type": "text", "className": "notes"}))
								)
							)
						),

						React.createElement(Button, {"type": "submit", "bsStyle": "primary", "disabled": (submitting)},
							React.createElement(InnerGlyphicon, {"spin": (submitting)}), """
\t\t\t\t\t\t\tSave
""")
					)
				)
			)
		)

module.exports = SummaryQuestionsComponent



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/olos/js/components/SummaryQuestions.cjsx